(function () {
  function initPromoPopup() {
    var root = document.querySelector('promo-popup');
    if (!root) return;
    var testMode = root.getAttribute('data-test-mode') === 'true';
    var delayDays = parseInt(root.getAttribute('data-delay-days'), 10) || 30;
    var delaySeconds = parseFloat(root.getAttribute('data-delay-seconds')) || 5;
    var displayTimer = root.getAttribute('data-display-timer') === 'true';
    var timerDuration = parseFloat(root.getAttribute('data-timer-duration')) || 3;
    var overlay = root.querySelector('.sign-up-popup-overlay');
    var modal = root.querySelector('.sign-up-popup-modal');
    var storageKey = 'promo-popup-dismissed-' + window.location.host;

    function openPopup() {
      if (overlay) overlay.classList.add('popup-overlay--active');
      if (modal) modal.classList.add('popup-modal--active');
      if (displayTimer) startTimer();
    }
    function closePopup() {
      if (overlay) overlay.classList.remove('popup-overlay--active');
      if (modal) modal.classList.remove('popup-modal--active');
      try {
        localStorage.setItem(storageKey, JSON.stringify({ dismissedAt: Date.now() }));
      } catch (e) {}
    }
    function startTimer() {
      var minutesEl = root.querySelector('.popup-modal__timer__minutes');
      var secondsEl = root.querySelector('.popup-modal__timer__seconds');
      if (!minutesEl || !secondsEl) return;
      var totalSeconds = Math.round(timerDuration * 60);
      var remaining = totalSeconds;
      function render() {
        var m = Math.floor(remaining / 60);
        var s = remaining % 60;
        minutesEl.textContent = (m < 10 ? '0' : '') + m;
        secondsEl.textContent = (s < 10 ? '0' : '') + s;
      }
      render();
      var interval = setInterval(function () {
        remaining--;
        if (remaining < 0) { clearInterval(interval); return; }
        render();
      }, 1000);
    }

    root.querySelectorAll('.promp-popup__close-btn').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closePopup();
      });
    });

    if (testMode) {
      openPopup();
      return;
    }

    var dismissed = null;
    try { dismissed = JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch (e) {}
    if (dismissed && dismissed.dismissedAt) {
      var daysSince = (Date.now() - dismissed.dismissedAt) / 86400000;
      if (daysSince < delayDays) return;
    }

    setTimeout(openPopup, delaySeconds * 1000);
  }

  if (document.readyState !== 'loading') initPromoPopup();
  else document.addEventListener('DOMContentLoaded', initPromoPopup);
})();
